var MDB = window.MDB || {};

(function ($) {
    var _createIndividualPlayer = function(player){
        //Players should be lazy loaded due to the enormous amount of memory they consume
        
        var rate = 1
            , isPlaying = false
            , playerIsReady = false
            , isSliding = false
            , isNotifyingPlayerProgress = false
            , initialPosition = player.data('position')
            , position = initialPosition !== undefined ? initialPosition : 0
            , progressSlider = player.find('.audio-player-progress')
            , howlerPlayer = undefined;


        progressSlider.slider({
            min: 0,
            step: 1,
            value: 0,
            tooltip: 'always',
            tooltip_position: 'bottom',
            enabled: false,
            formatter: function () {
                var d = new Date(0, 0, 0, 0, 0, 0, Math.round(position * 1000));

                return formatDateParts(d);
            }
        });

        progressSlider.slider('on', 'slideStart', function () {
            isSliding = true;
        });

        progressSlider.slider('on', 'change', function (data) {
            if (!isSliding) {
                ensureHowlerPlayer();
                howlerPlayer.seek(data.newValue);
            }
        });

        progressSlider.slider('on', 'slideStop', function (val) {
            ensureHowlerPlayer();
            
            howlerPlayer.seek(val);
            isSliding = false;
        });

        player.on('click', '.audio-player-pause', function (e) {
            e.preventDefault();
            
            ensureHowlerPlayer();
            
            howlerPlayer.pause();
        });

        player.on('click', '.audio-player-play', function (e) {
            e.preventDefault();
            
            ensureHowlerPlayer();
            
            if (!isPlaying) {
                howlerPlayer.play();
            }
        });

        player.on('click', '.audio-player-seek', function (e) {
            e.preventDefault();
            
            ensureHowlerPlayer();
            
            howlerPlayer.seek(howlerPlayer.seek() + $(this).data('seconds'));
        });

        player.on('click', '.audio-player-change-rate', function (e) {
            e.preventDefault();

            ensureHowlerPlayer();
            
            //Seek position gets set back to 0 when stop is called, update it manually
            position = howlerPlayer.seek();

            //The rate can only be consistently changed when instantiating a new howler object
            //Replace the old howler object with a new one with the desired rate
            howlerPlayer.stop();
            howlerPlayer = null;

            var newRate = $(this).data('rate');
            rate = rate === newRate ? 1 : newRate;

            ensureHowlerPlayer();
        });

        function ensureHowlerPlayer(){
            if(!howlerPlayer){
                howlerPlayer = createHowlerPlayer();
            }
        }

        function createHowlerPlayer() {
            var howlerPlayer = new Howl({
                src: [player.data('audio-url')],
                format: ['mp3'],
                rate: rate
            });

            howlerPlayer.on('play', function () {
                isPlaying = true;
            });

            howlerPlayer.on('pause', function () {
                isPlaying = false;
            });

            howlerPlayer.on('end', function () {
                isPlaying = false;
            });

            howlerPlayer.on('seek', function () {
                position = this.seek();
                updatePlayerProgress();
            });

            howlerPlayer.on('load', function () {
                progressSlider.slider('setAttribute', 'max', this.duration());
                progressSlider.slider('enable');
                
                playerIsReady = true;
                updatePlayerProgress();
            });

            howlerPlayer.seek(position);

            if (isPlaying) {
                howlerPlayer.play();
            }

            scheduleProgressNotifier();

            return howlerPlayer;
        }

        function formatDateParts(d) {
            return MDB.padLeft(d.getHours(), '0', 2) + ':' +
                MDB.padLeft(d.getMinutes(), '0', 2) + ':' +
                MDB.padLeft(d.getSeconds(), '0', 2);
        }

        function updatePlayerProgress() {
            if(!howlerPlayer){
                return;
            }
            
            position = howlerPlayer.seek();
            var duration = howlerPlayer.duration() || 0;
            var percentagePlayed = duration > 0 ? ((position / duration) * 100) : 0;

            if (position !== player.data('position')) {
                player.data('position', position);
                player.trigger('position-changed', [position, percentagePlayed]);


                if (playerIsReady && !isSliding) {
                    progressSlider.slider('setValue', position);
                }
            }
        }
        
        function scheduleProgressNotifier(){
            if(isNotifyingPlayerProgress){
                return;
            }
            
            isNotifyingPlayerProgress = true;
            
            setTimeout(function updatePlayerProgressInterval() {
                //Upon player deactivation, stop wasting resources
                if(!isNotifyingPlayerProgress){
                    return;
                }
                
                setTimeout(function () {
                    updatePlayerProgress();
                    updatePlayerProgressInterval();
                }, 1000);
            }, 0);   
        }
    };
    
    $.extend(MDB, {         
        createAudioPlayer: function (player) {
            player.each(function(){
                _createIndividualPlayer($(this));
            });
        },

        /**
         * Build an audio player HTML element
         * 
         * @param {Object} configuration Audio player configuration
         * @param {String} configuration.source Audio URL
         * 
         * @returns {HTMLDivElement}
         */
        createAudioPlayerElement: function(configuration) {
            var player = document.createElement('div')
              , pauseButton = document.createElement('button')
              , pauseButtonIcon = document.createElement('i')
              , playButton = document.createElement('button')
              , playButtonIcon = document.createElement('i')
              , progressTrack = document.createElement('input');
            
            player.setAttribute('data-audio-url', configuration.source);
            
            player.className = 'audio-player';
            pauseButton.className = 'btn btn-primary btn-circle btn-md audio-player-pause'
            pauseButtonIcon.className = 'fa fa-pause';
            playButton.className = 'btn btn-primary btn-circle btn-md audio-player-play';
            playButtonIcon.className = 'fa fa-play';
            progressTrack.className = 'audio-player-progress hidden';

            pauseButton.append(pauseButtonIcon);
            playButton.append(playButtonIcon);
            player.append(pauseButton, playButton, progressTrack);
            
            return player;
        }
    });
}(jQuery));